import {
  IMAGE_PREFIX_ID,
  MASK_PREFIX_ID, MULTI_LINE_PREFIX_ID,
  RECTANGLE_PREFIX_ID,
  TEXT_PREFIX_ID
} from '@frontend/constants/templates-field-prefixes';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { fabric } from 'fabric';
import { FIELD_TYPE_SMART_OBJECT } from "@frontend/constants/type-fields-of-template";
import {DEFAULT_SMART_OBJECT_FIELD_PROPERTIES} from "@frontend/group/modules/additional-fields";
import {removeAllElementParamsAndChanges} from "@/common/preview/remove-all-element-params-and-changes";
import {removeObjectFromCanvas} from "@frontend/utils";

const getScopePage = () => ShowPageScopeCollector.get([
  'handleObjectMoving',
  'canvas_data',
  'updateLayoutChanges',
  'reorderObjectCanvas',
  'saveLayout'
]);
export const SMART_OBJECT_BACKGROUND_COLOR = '#FFFFFF80';

export async function drawSmartObject({ fields, canvas, group_fields, dimension, data, user_fields_order }) {
  canvas.getObjects().forEach(function (o) {
    if (o.id.startsWith(MASK_PREFIX_ID)) {
      canvas.remove(o);
    }
  });
  const instanceId = canvas?.instance_id;
  const { handleObjectMoving, canvas_data, updateLayoutChanges, reorderObjectCanvas } = getScopePage();
  const canvasData = canvas_data?.[instanceId];
  
  let smartFields = [];
  
  fields.map(field => {
    if (field.type === 'Smart Object') {
      field.isAdditional = false;
      smartFields.push(field);
    }
  })
  
  if (canvasData && Object.hasOwn(canvasData, 'additionalSmartObjects')) {
    canvasData.additionalSmartObjects.map(field => {
      smartFields.push({
        options: JSON.stringify(data[`${field}_options`]),
        type: 'Smart Object',
        element_id: field,
        name: data[`${field}_group_name`],
        isAdditional: true,
      })
    })
    
  }

  
  let iter = 0;
  smartFields.forEach((field) => {
    const options = JSON.parse(field.options);
    const element_id = field.element_id;
    let option5;
    if (typeof data[`${element_id}_options`] === 'string') {
      try {
        option5 = JSON.parse(data[`${element_id}_options`]);
      } catch (e) {
        option5 = JSON.parse(DEFAULT_SMART_OBJECT_FIELD_PROPERTIES._options);
      }
    } else {
      option5 = data[`${element_id}_options`];
    }

    if (field.type === FIELD_TYPE_SMART_OBJECT && option5) {
      iter++;
      const groupName = data[`${element_id}_group_name`];
      const width = data && Object.hasOwn(data, `${element_id}_width`) ? +data[`${element_id}_width`] : parseInt(options['Width']);
      const height = data && Object.hasOwn(data, `${element_id}_height`) ? +data[`${element_id}_height`] : parseInt(options['Height']);
      const left = data && Object.hasOwn(data, `${element_id}_x`) ? +data[`${element_id}_x`] : parseInt(options['X']) + dimension[4].x - dimension[2];
      const top = data && Object.hasOwn(data, `${element_id}_y`) ? +data[`${element_id}_y`] : parseInt(options['Y']) + dimension[4].y - dimension[3];
      const members = data && (data[`${element_id}_additional_members`] ?? null);
      const membersIds = canvas.getObjects()
        .filter(obj => obj.groupName === groupName)
        .map(obj => obj.fieldId ? String(obj.fieldId) : obj.id)
        .filter(memberId => members ? members.includes(memberId) : true);
      const fill = data[`${element_id}_fill`] || SMART_OBJECT_BACKGROUND_COLOR;

      const radius = parseInt(option5.mask.radius);
      let shadow = option5.shadow;
      const order = parseInt(options['Order']) || 1000;
      const movable = true;
      const rect = new fabric.Rect({
        id: MASK_PREFIX_ID + '_' + iter,
        element_id: element_id,
        groupName: groupName,
        order: order,
        left: left,
        top: top,
        width: width,
        height: height,
        fill: 'red',
        rx: radius,
        ry: radius,
        absolutePositioned: true,
        scaleX: 1,
        scaleY: 1,
      });

      if (shadow && (shadow.enabled ?? true)) {
        shadow = makeSmartObjectShadow(shadow);
      } else {
        shadow = null;
      }

      const frame = new fabric.Rect({
        id: MASK_PREFIX_ID + '_' + iter,
        element_id: element_id,
        groupName: groupName,
        order: order + 1,
        left: left,
        top: top,
        width: width,
        height: height,
        fill: _.isBoolean(option5.showBackground)
          ? (option5.showBackground ? (data[`${element_id}_fill`] || SMART_OBJECT_BACKGROUND_COLOR) : 'transparent')
          : fill,
        rx: radius,
        ry: radius,
        shadow: shadow,
        absolutePositioned: true,
        selectable: false,
        evented: false,
        fieldId: field.id,
        backupFieldOptions: null,
        fieldOptionChanges: {},
        templateField: field,
        isSelectedByUi: false,
        isObjectChanged: false,
        isSaving: false,
        scaleX: 1,
        scaleY: 1,
        options: option5,
        isAdditional: field.isAdditional,
        name: field.name,
        skew: {
          value: [0,0,0,0,0,0,0,0],
        },
        prevPosition: {
          left: left,
          top: top,
        },
        clipPathArea: rect,
        members: membersIds,
        // cancelChanges() {
        //   if (!this.isSelectedByUi) return;
        //   this.isObjectChanged = false;
        //   const { mask, shadow, skew } = JSON.parse(this.backupFieldOptions);
        //   this.set('shadow', this.makeShadow({
        //     ...shadow
        //   }));
        //   // const movable = this.backupFieldOptions['Moveable'] && this.backupFieldOptions['Moveable'] === 'Yes';
        //   const movable = true;
        //   this.set('rx', parseFloat(mask.radius));
        //   rect.set('rx', parseFloat(mask.radius));
        //   this.set('ry', parseFloat(mask.radius));
        //   rect.set('ry', parseFloat(mask.radius));
        //   if (this.backupSizeAndPosition) {
        //     this.set('left', this.backupSizeAndPosition.left);
        //     rect.set('left', this.backupSizeAndPosition.left);
        //     this.set('top', this.backupSizeAndPosition.top);
        //     rect.set('top', this.backupSizeAndPosition.top);
        //     this.set('width', this.backupSizeAndPosition.width);
        //     rect.set('width', this.backupSizeAndPosition.width);
        //     this.set('height', this.backupSizeAndPosition.height);
        //     rect.set('height', this.backupSizeAndPosition.height);
        //   }
        //   this.set('locked', !movable);
        //   rect.set('locked', !movable);
        //   if (this.skew) {
        //     this.set('skew', { ...(this.skew || {}), value: skew?.value, render: false });
        //   }
        //   // if (this.backupFieldOptions['Movable'] && options['Moveable'] !== 'Yes') {
        //   //   this.evented = false;
        //   //   this.selectable = false;
        //   // }
        //   this.setCoords();
        //   rect.setCoords();
        //   setOrder(this.canvas);
        //   this.canvas.renderAll();
        //   rect?.canvas?.renderAll();
        //   this.isSelectedByUi = false;
        //
        //   canvas.getObjects().forEach(function (o) {
        //     if (o.groupName === groupName && o.element_id !== element_id) {
        //       o.smartObject = frame;
        //       o.clipPath = rect;
        //     }
        //   });
        //
        //   this.updateMembers();
        // },
        async deleteSmartObject(instanceID) {
          await Swal.fire({
            title: 'Are you sure you want to delete this field?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Cancel',
            icon: 'warning',
            width: '32em',
            preConfirm: async () => {
              const { saveLayout } = getScopePage();

              Swal.showLoading();

              const grid = $("#template-group-preview");
              const customer_id = grid.attr("data-customer-id");
              const layout_id = grid.attr("data-layout-id");

              await axios.post(
                `/banner/${customer_id}/group/${layout_id}/delete-add-field`,
                {
                  fieldKey: this.element_id,
                  instance_id: instanceID,
                }
              );

              for (const memberId of this.members) {
                this.removeMember(memberId, { preventChangesUpdate: true });
              }

              removeAllElementParamsAndChanges(canvas.instance_id, element_id);
              removeObjectFromCanvas(canvas, this.id, { exactMatch: true });
              saveLayout();

              return true;
            },
          });
        },
        updateMembers() {
          const offset = {
            x: this.left - this.prevPosition.left,
            y: this.top - this.prevPosition.top
          }

          if (offset.x === 0 && offset.y === 0) {
            return;
          }

          this.canvas.getObjects().forEach((obj) => {
            if (obj.groupName === this.groupName && obj.element_id !== this.element_id) {
              obj.set({
                left: obj.left + offset.x,
                top: obj.top + offset.y
              });

              updateMemberCanvasDataCoords(obj, canvasData, offset);

              handleObjectMoving({ target: obj });
            }
          });

          this.prevPosition = {
            left: this.left,
            top: this.top
          };
        },
        addMember(elementId) {
          const isBaseFieldId = !isNaN(parseInt(elementId));
          const obj = this.canvas.getObjects().find(obj => String((isBaseFieldId ? obj.fieldId : obj.id)) === elementId);

          if (!obj) {
            console.warn('Element to add was not found!')
            return;
          }

          obj.set({
            groupName: groupName,
            clipPath: this.clipPathArea,
            smartObject: this,
          });

          const offset = {
            x: this.left,
            y: this.top
          };

          updateMemberCanvasDataCoords(obj, canvasData, offset);
          handleObjectMoving({ target: obj });

          this.members.push(elementId);
          this.updateChanges();
        },
        removeMember(elementId, options = {}) {
          const { preventChangesUpdate = false } = options;

          const isBaseFieldId = !isNaN(parseInt(elementId))
          const obj = this.canvas.getObjects().find(obj => String((isBaseFieldId ? obj.fieldId : obj.id)) === elementId);

          if (!obj) {
            console.warn('Element to remove was not found!')
            return;
          }

          obj.set({
            groupName: null,
            clipPath: null,
            smartObject: null,
          });

          const offset = {
            x: -this.left,
            y: -this.top
          };

          updateMemberCanvasDataCoords(obj, canvasData, offset);
          handleObjectMoving({ target: obj });

          this.members = this.members.filter(memberId => memberId !== elementId);

          if (!preventChangesUpdate) {
            this.updateChanges();
          }
        },
        updateClipPath() {
          this.clipPathArea.set({
            left: this.left,
            top: this.top,
            rx: this.rx,
            ry: this.ry,
            width: this.width,
            height: this.height,
            scaleX: this.scaleX,
            scaleY: this.scaleY
          });
        },
        updateChanges(model = null) {
          if (!this.backupFieldOptions) {
            this.backupFieldOptions = JSON.stringify(this.options);
          }

          const smartObjCoords = canvas_data[instanceId].smartObjCoords[this.groupName];
          
          //ignore cases when SO is not initialized 
          if (!smartObjCoords) return;

          smartObjCoords.X = this.left;
          smartObjCoords.Y = this.top;

          this.updateMembers();
          this.updateClipPath();

          if (model) {
            this.options.mask.radius = model.radius;
            this.options.shadow = {
              angle: model.angle,
              distance: model.distance,
              opacity: model.opacity,
              size: model.size,
              enabled: model.showShadow
            }
            this.options.showBackground = model.showBackground;
          }

          this.options.skew = {
            value: this.skew.value,
            render: this.skew.render
          }

          const layoutChanges = [
            {
              instance_id: instanceId,
              key: `${this.element_id}_additional_members`,
              value: this.members
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_options`,
              value: JSON.stringify(this.options)
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_width`,
              value: parseInt(this.width * this.scaleX)
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_height`,
              value: parseInt(this.height * this.scaleY)
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_x`,
              value: parseInt(this.left)
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_y`,
              value: parseInt(this.top)
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_group_name`,
              value: this.groupName
            },
            {
              instance_id: instanceId,
              key: `${this.element_id}_fill`,
              value: this.options.fill || SMART_OBJECT_BACKGROUND_COLOR
            }
          ];

          for (const change of layoutChanges) {
            updateLayoutChanges(change.instance_id, change.key, change.value);
          }

          this.canvas.renderAll();
        }
      });

      if (movable) {
        frame.selectable = true;
        frame.evented = true;
        rect.selectable = true;
        rect.evented = true;
      }

      frame.set('locked', !movable);

      let skew = [0,0,0,0,0,0,0,0];
      let isNeedToSkew = false;

      if (Array.isArray(option5.skew?.value) && option5.skew.value.length === 8) {
        skew = option5.skew;
        isNeedToSkew = true;
      } else if (
        options['Option1'] === 'Transform' &&
        options['Option2'] === 'skew'
      ) {
        const parsedSkew = options['Option3'].split(',').map(Number);
        if (parsedSkew.length === 8 && parsedSkew.every(n => !isNaN(n))) {
          skew = { value: parsedSkew };
          isNeedToSkew = true;
        }
      }

      if (isNeedToSkew) {
        frame.skew = skew
      }

      const debouncedUpdate = _.debounce(function () {
        frame.updateChanges();
      }, 500);

      frame.on({
        'skew:changed': debouncedUpdate
      });

      canvas.add(frame);
      
      if (user_fields_order && frame.isAdditional && !user_fields_order.includes(frame.id)) {
        user_fields_order.push(frame.id);
        updateLayoutChanges(options.currentInstanceId, 'users_fields_order', JSON.stringify(user_fields_order));
      }

      canvas.getObjects().forEach(function (o) {
        if (o.groupName === groupName && o.element_id !== element_id) {
          o.clipPath = rect;
          o.smartObject = frame;
        }
      });
    }
  });

  reorderObjectCanvas(canvas);
}

/**
 * Since the offsets of smart object members are relative to the smart object itself,
 * if the smart object has moved, we need to adjust the base coordinates of the element as well.
 */
function updateMemberCanvasDataCoords(memberObj, canvasData, shift) {
  const id = memberObj.id;
  const index = parseInt(id.split("_").pop());

  if (id.includes(TEXT_PREFIX_ID)) {
    canvasData.textCoords[index].x += shift.x;
    canvasData.textCoords[index].y += shift.y;
  } else if (id.startsWith(RECTANGLE_PREFIX_ID)) {
    canvasData.rectCoords[index].x += shift.x;
    canvasData.rectCoords[index].y += shift.y;
  } else if (id.includes(IMAGE_PREFIX_ID)) {
    canvasData.originCoords[index].x += shift.x;
    canvasData.originCoords[index].y += shift.y;
  } else if (id.startsWith(MULTI_LINE_PREFIX_ID)) {
    canvasData.multiLineTextCoords[index].x += shift.x;
    canvasData.multiLineTextCoords[index].y += shift.y;
  }
}

function getSmartObjectsIds(canvasData) {
  const { templateInstance, additionalSmartObjects } = canvasData;
  const fieldsElementsIds = templateInstance.fields
    .filter(field => field.type === FIELD_TYPE_SMART_OBJECT)
    .map(field => field.element_id);

  return fieldsElementsIds.concat(additionalSmartObjects);
}

export function getGroupNameByAddFieldId(addFieldId, canvasData) {
  const smartObjectsFields = getSmartObjectsIds(canvasData);
  const { _data: data } = canvasData;

  let groupName = null;
  for (let element_id of smartObjectsFields) {
    const additionalFieldsMembers = data[`${element_id}_additional_members`] || [];
    const name = data[`${element_id}_group_name`] || null;

    if (additionalFieldsMembers.some(memberId => memberId+'' === addFieldId+'')) {
      groupName = name;
    }
  }
  return groupName;
}

export function makeSmartObjectShadow({ opacity, size, distance, angle }) {
  return new fabric.Shadow({
    color: `rgba(0, 0, 0, ${parseFloat(opacity) / 100})`,
    blur: (parseFloat(size) || 1) * 2,
    offsetY: -1 * parseFloat(distance) * Math.sin((Math.PI * 2 * parseFloat(angle)) / 360),
    offsetX: parseFloat(distance) * Math.cos((Math.PI * 2 * parseFloat(angle)) / 360),
  });
}
